import { useNavigate } from "react-router-dom";
import UserList from "../../features/manageUsers/userList";
import usePermission from "../../hooks/userAccess";

const ManageUser = () => {
  const navigate = useNavigate();

  const { isView } = usePermission({
    label: 'Manage Users',
    page_permission: 'isView',
  });

  return (
    <>
      <div className="main_title">
        <h1>Manage Users</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
          - Manage Users
        </p>
      </div>
      {isView && <div className="cards">
        <UserList />
      </div>}
    </>
  );
};

export default ManageUser;
